import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { InlineAlertComponent } from '../inline-alert/inline-alert';
import { Button, CloseIconComponent } from '@arm-web/ui-components';

/**
 * ToastContainerComponent
 *
 * Global container that renders active toast notifications.
 * Placed once in the root App component so toasts appear on every page.
 *
 * Toasts are positioned fixed at the top-right (end) of the viewport
 * and stack vertically with smooth enter/exit animations.
 */
@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [InlineAlertComponent, Button, CloseIconComponent],
  templateUrl: './toast-container.html',
  styleUrl: './toast-container.css',
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);
}
